angular.module('rjmNg.directives').directive "metricsManage", [
  () ->
    restrict: "E"
    templateUrl: "directive.metricsManage.html"
    replace: false
    controllerAs: "view"
    bindToController: true
    scope:
      message: "="
    controller: [
      "$q"
      "$url"
      "app"
      "appParams"
      "appRoute"
      "dependencyEnums"
      "errorConstants"
      "FilterSets"
      "Metrics"
      "metricEnums"
      "notification"
      "StructureCache"
      (
        $q
        $url
        app
        appParams
        appRoute
        dependencyEnums
        errorConstants
        FilterSets
        Metrics
        metricEnums
        notification
        StructureCache
      ) ->

        view = @

        _clientId = null
        _resourceTypes = Object.keys(dependencyEnums.RESOURCE_DEPENDENCIES)
        _notificationTimeout = 10

        view.isAdmin = app.isAdminUser()
        view.metrics = []
        view.metricGroups = []
        view.tables = []
        view.columns = []
        view.filterSets = {}
        view.showOnlyUnused = false

        view.createMetricUrl = appRoute('/settings/metric/edit')

        _loadMetricsAndStructure = ->
          view.loading = true
          $q.all([
            StructureCache.getStructure(),
            Metrics.getAll(_clientId, true)
          ]).then(
            (response) ->
              [structure, metrics] = response
              view.tables = _.map(structure.tables, (tb) -> return tb )
              view.columns = _.map(structure.columns, (col) -> return col )
              view.tablesMap = structure.tables
              view.columnsMap = structure.columns
              view.metrics = angular.copy(metrics)
              view.metricGroups = _getMetricGroups(view.metrics)
              view.loading = false
            , (error) ->
              view.loading = false
              console.log(error)
              notification.error("Server Error",
                errorConstants.SERVER_ERROR_MESSAGE,
                "metrics",
                null,
                _notificationTimeout
              )
          )

        _getMetricGroups = (metrics) ->
          _.chain(metrics)
            .map((met) -> 
              met.displayOp = metricEnums.AGGREGATE_FUNCTIONS[met.operation.toUpperCase()]
              met.table = view.tablesMap[met.table_id]
              met.editUrl = appRoute('/settings/metric/edit/' + met.id)
              met.cloneUrl = appRoute('/settings/metric/edit/') + '?cloneId=' + met.id
              met.dimensions = met.dimensions.filter((dim) -> return dim.column_id ) #web service returns one dim with null id if 0 dims
              met
            )
            .groupBy((met) -> ( met.table.name ))
            .map((grp, key) -> 
              newGrp = {}
              newGrp.name = key
              newGrp.metrics = grp
              newGrp
            )
            .value()

        _setConfirmDeleteCallBack = (promiseFn) ->
          return (selection) ->
            view.loading = true
            promiseFn(selection).finally(() -> 
              view.loading = false
            )

        _updateMetricDetails = (metric) ->
          tempMet = _.find(view.metrics, (met) -> return met.id is metric.id)
          if(view.isAdmin)
            tempMet.filLoading = true
            Metrics.dependents(_clientId, metric.id).then((response)->
              hasTypes = _.intersection(Object.keys(response), _resourceTypes)
              if(hasTypes.length > 0)
                tempMet.dependents = response
              else
                tempMet.dependents = null
            ,(error)->
              console.log(error)
              notification.error("Server Error",
                errorConstants.SERVER_ERROR_MESSAGE,
                "metrics",
                null,
                _notificationTimeout
              )
            ).finally(() ->
              tempMet.filLoading = false
            )
          Metrics.getFullMetricInfo(_clientId, metric.id).then((metSuccess) ->
            tempMet.details = metSuccess  
            tempMet.details.dimensions = _.filter(tempMet.details.dimensions, (dim) -> return dim.column_id)
          ,(error) ->
            console.log(error)
            notification.error("Server Error",
              errorConstants.SERVER_ERROR_MESSAGE,
              "metrics",
              null,
              _notificationTimeout
            )
          )


        view.showBulkEdit = (type) ->
          view.showBulkEditFlag = true
          $('#bulk-edit-modal').modal()
          view.dimensionEditorAction = metricEnums.DIMENSION_EDITOR_ACTIONS[type]
        
        view.cancelBulkEdit = () ->
          $('#bulk-edit-modal').modal('hide')
          view.showBulkEditFlag = false

        view.showDepResolver = (dep) ->
          $('#bulk-edit-modal').modal('hide')
          view.showBulkEditFlag = false
          view.dependencyPromises = dep.dependencyPromises
          view.showDependencyResolver = true
          view.depReadOnly = false
          view.depResourceType = dep.depResourceType
          view.dependencyTypes = dep.dependencyTypes
          view.depResourceNames = dep.depResourceNames
          view.depConfirmMsg = dep.depConfirmMsg
          view.confirmDeleteCallback = _setConfirmDeleteCallBack(dep.confirmDelete)

        view.filterOnlyUnused = (flag) ->
          view.showOnlyUnused = flag
          if(flag)
            filteredMetrics = _.filter(view.metrics, (met) -> return met.report_usage is !flag)
          else
            filteredMetrics = view.metrics
          view.metricGroups = _getMetricGroups(filteredMetrics)

        view.updateMetricDetails = _updateMetricDetails

        view.updateMetrics = (metrics) ->
          _.each(metrics, (metToUpdate) ->
            tempMet = _.find(view.metrics, (ogMet) -> return ogMet.id is metToUpdate.id)
            _updateMetricDetails(tempMet)
            tempMet.dimensions = angular.copy(metToUpdate.dimensions.filter((dim) -> return dim.column_id ))
          )
        
        view.removeMetrics = (metricIds) ->
          view.metrics = _.reject(view.metrics, (met) -> return _.contains(metricIds, met.id))
          view.metricGroups = _getMetricGroups(view.metrics)

        view.$postLink = () ->
          view.showOnlyUnused = false
          _clientId = appParams.clientId
          _loadMetricsAndStructure()

        return view
    ]
]
